import { defineMessages } from "react-intl";

export const messages = defineMessages({
  privacyPolicyValidFromLabel: {
    id: "settings.privacyPolicy.validFrom.label",
    defaultMessage: "Valid from",
    description: "Label for valid from for current agreement or policy",
  },
});
